var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationMyMeterRatings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 23.5C18.0751 23.5 23 18.5751 23 12.5C23 6.42487 18.0751 1.5 12 1.5C5.92487 1.5 1 6.42487 1 12.5C1 18.5751 5.92487 23.5 12 23.5Z",
    stroke: "#6A6A6A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66992 9.89002C5.2143 8.36768 6.2194 7.05274 7.54556 6.12797C8.87172 5.20321 10.4531 4.71457 12.0697 4.72997C13.6864 4.74536 15.2581 5.26404 16.5664 6.21389C17.8747 7.16374 18.8546 8.49758 19.3699 10.03",
    stroke: "#6A6A6A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.10938 16.1099C5.76943 17.3642 6.75962 18.4145 7.97302 19.1471C9.18643 19.8798 10.5769 20.267 11.9944 20.267C13.4118 20.267 14.8023 19.8798 16.0157 19.1471C17.2291 18.4145 18.2193 17.3642 18.8794 16.1099H5.10938Z",
    stroke: "#6A6A6A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.46 15.0301L16.49 11.1101",
    stroke: "#6A6A6A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0504 14.5498C11.8447 14.5485 11.6408 14.5879 11.4504 14.6657C11.26 14.7435 11.0868 14.8582 10.9409 15.0032C10.795 15.1482 10.6792 15.3206 10.6002 15.5105C10.5211 15.7005 10.4805 15.9041 10.4805 16.1098H13.6105C13.6105 15.905 13.5701 15.7021 13.4917 15.5129C13.4133 15.3236 13.2984 15.1516 13.1535 15.0067C13.0087 14.8619 12.8367 14.747 12.6475 14.6686C12.4582 14.5902 12.2553 14.5498 12.0504 14.5498Z",
    fill: "#6A6A6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationMyMeterRatings);
export default __webpack_public_path__ + "static/media/navigation-my-meter-ratings.bd98725cfe38d74b91a9c986f4cbb033.svg";
export { ForwardRef as ReactComponent };